export default "__VITE_ASSET__bf8ad840__"